import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import AppBar from "./Common/AppBar";
import Drawer from "./Common/Drawer";
import Copyright from "./Common/Copyright";
import Chart from "./Dashboard/Chart";
import IssueList from "./Structured/IssueList";
import ValueBox from "./Dashboard/ValueBox";

// TODO remove, this demo shouldn"t need to reset the theme.
const defaultTheme = createTheme();

export const Structured = ({ token }) => {
  const [open, setOpen] = React.useState(false);
  const [DeployReminder, setDeployReminder] = React.useState(false);
  const toggleDrawer = () => {
	setOpen(!open);
  };

  const fetchDeployReminder = async () => {
	const response = await fetch(`${process.env.REACT_APP_API_URL}/structured/undeployed`, 
        { 
            method: "GET", 
            headers: {
                "Content-Type": "application/json",
                "Token": token
            }
        }
    );
	const data = await response.json();
	setDeployReminder(data.undeployed);
  };

  React.useEffect(() => { 
	fetchDeployReminder();
	}, []);

  return (
	<ThemeProvider theme={defaultTheme}>
	  <Box sx={{ display: "flex" }}>
		<CssBaseline />
		<AppBar open={open} toggleDrawer={toggleDrawer} />
		<Drawer open={open} toggleDrawer={toggleDrawer} />
		<Box
		  component="main"
		  sx={{
			backgroundColor: (theme) =>
			  theme.palette.mode === "light"
				? theme.palette.grey[100]
				: theme.palette.grey[900],
			flexGrow: 1,
			height: "100vh",
			overflow: "auto",
		  }}
		>
		  <Toolbar />
		  {DeployReminder && (
			<Box
				sx={{
				backgroundColor: defaultTheme.palette.error.main,
				color: defaultTheme.palette.error.contrastText,
				padding: "8px",
				textAlign: "center",
				}}
			>
				You have undeployed changes!
			</Box>
			)}
		  <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
			<Grid container spacing={3}>
			  {/* Issues */}
			  <Grid item xs={12}>
				<Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
				  <IssueList onDeployToModel={ fetchDeployReminder } token={ token } />
				</Paper>
			  </Grid>
			</Grid>
			<Copyright sx={{ pt: 4 }} />
		  </Container>
		</Box>
	  </Box>
	</ThemeProvider>
  );
}

export default Structured;